import request from '@/utils/request'


// 查询师傅提现列表
export function listWithdrawal(query) {
  return request({
    url: '/master/master-withdrawal/list',
    method: 'get',
    params: query
  })
}

// 查询师傅提现分页
export function pageWithdrawal(query) {
  return request({
    url: '/master/master-withdrawal/page',
    method: 'get',
    params: query
  })
}

// 查询师傅提现详细
export function getWithdrawal(data) {
  return request({
    url: '/master/master-withdrawal/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅提现
export function addWithdrawal(data) {
  return request({
    url: '/master/master-withdrawal/add',
    method: 'post',
    data: data
  })
}

// 修改师傅提现
export function updateWithdrawal(data) {
  return request({
    url: '/master/master-withdrawal/edit',
    method: 'post',
    data: data
  })
}

// 审核通过师傅提现
export function approveWithdrawal(data) {
  return request({
    url: '/master/master-withdrawal/approve',
    method: 'post',
    data: data
  })
}

// 审核驳回师傅提现
export function rejectWithdrawal(data) {
  return request({
    url: '/master/master-withdrawal/reject',
    method: 'post',
    data: data
  })
}

// 删除师傅提现
export function delWithdrawal(data) {
  return request({
    url: '/master/master-withdrawal/delete',
    method: 'post',
    data: data
  })
}
